/**
 * Chat direct message class
 */
export default class {
  constructor (data) {
    this.id = data._id
    this.to_user = data.to_user
    this.t = data.t
    this.usernames = data.usernames
    this.msgs = data.msgs
    this.usersCount = data.usersCount
    this.uids = data.uids
    this.ts = data.ts
    this.ro = data.ro
    this.default = data.default
    this.sysMes = data.sysMes
    this.updatedAt = data._updatedAt
    this.lastMessage = data.lastMessage
    this.unread = ~~data.unread
    this.isSms = data.is_sms
    this.open = data.subscription.open
    this.displayUsername = data.to_user?.name
    this.lastMessageTs = data.lastMessage?.ts
  }

  formatChatUsername () {
    return this.to_user?.name
  }

  contextMenus () {
    return [
      { title: 'Hide', key: 'close', icon: 'mdi-eye-off', color: 'default' }
    ]
  }

  formatLastConversationMessagePreview () {
    let message = this.lastMessage?.msg
    if (this.lastMessage?.attachments?.length > 0) {
      const attachment = this.lastMessage?.attachments[0]
      const type = attachment?.image_type || attachment?.audio_type || attachment?.video_type
      if (type?.includes('image')) {
        message = `🖼️ ${message}`
      } else if (type?.includes('audio')) {
        message = `🔊 ${message}`
      } else if (type?.includes('video')) {
        message = `🎥 ${message}`
      }
    }
    if (message) {
      return `${message} ● `
    }
    return null
  }

  getFriendlyLastMessageDate () {
    return this.fromNow(this.lastMessage?.ts)
  }

  /**
   * Human readable elapsed or remaining time (example: 3 minutes ago)
   * @param  {Date|Number|String} date A Date object, timestamp or string parsable with Date.parse()
   * @param  {Date|Number|String} [nowDate] A Date object, timestamp or string parsable with Date.parse()
   * @param  {Intl.RelativeTimeFormat} [trf] A Intl formater
   * @return {string} Human readable elapsed or remaining time
   */
  fromNow (date, nowDate = Date.now(), rft = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })) {
    const SECOND = 1000
    const MINUTE = 60 * SECOND
    const HOUR = 60 * MINUTE
    const DAY = 24 * HOUR
    const WEEK = 7 * DAY
    const MONTH = 30 * DAY
    const YEAR = 365 * DAY
    const intervals = [
      { ge: YEAR, divisor: YEAR, unit: 'year' },
      { ge: MONTH, divisor: MONTH, unit: 'month' },
      { ge: WEEK, divisor: WEEK, unit: 'week' },
      { ge: DAY, divisor: DAY, unit: 'day' },
      { ge: HOUR, divisor: HOUR, unit: 'hour' },
      { ge: MINUTE, divisor: MINUTE, unit: 'minute' },
      { ge: 30 * SECOND, divisor: SECOND, unit: 'seconds' },
      { ge: 0, divisor: 1, text: 'just now' }
    ]
    const now = typeof nowDate === 'object' ? nowDate.getTime() : new Date(nowDate).getTime()
    const diff = now - (typeof date === 'object' ? date : new Date(date)).getTime()
    const diffAbs = Math.abs(diff)
    for (const interval of intervals) {
      if (diffAbs >= interval.ge) {
        const x = Math.round(Math.abs(diff) / interval.divisor)
        const isFuture = diff < 0
        const text = interval.unit ? rft.format(isFuture ? x : -x, interval.unit) : interval.text
        return { interval, number: x, text }
      }
    }
  }
}
